export function toHookName(methodName) {
  return "use" + methodName[0].toUpperCase() + methodName.substring(1);
}
export function toQueryName(methodName) {
  return "get" + methodName[0].toUpperCase() + methodName.substring(1);
}
export function getApiUrl(methodConfig) {
  var _ref;
  const path = (_ref = methodConfig.path) != null ? _ref : "/" + methodConfig.name;
  return "" + methodConfig.service.baseUrl + path;
}
export function getResourcefulApiUrl(methodConfig, request) {
  var _ref2;
  let path = (_ref2 = methodConfig.path) != null ? _ref2 : "/" + methodConfig.name;
  if (request && path.includes('/:')) {
    const pathComponents = path.split('/').map(component => {
      if (component[0] !== ':') {
        return component;
      }
      const resource = component.substring(1);
      const value = (request != null ? request : {})[resource];
      return value != null ? value : component;
    });
    path = pathComponents.join('/');
  }
  return "" + methodConfig.service.baseUrl + path;
}
export function getApiUrlComponents(methodConfig) {
  var _ref3;
  const path = (_ref3 = methodConfig.path) != null ? _ref3 : "/" + methodConfig.name;
  return [methodConfig.service.baseUrl, path];
}
export function getOrderedQueryKey(request) {
  if (Array.isArray(request)) {
    return request.map(getOrderedQueryKey).sort();
  } else if (typeof request === 'object') {
    return Object.entries(request).sort((a, b) => a[0].localeCompare(b[0])).map(_ref4 => {
      let [k, v] = _ref4;
      return [k, getOrderedQueryKey(v)];
    }).flat();
  } else {
    return request;
  }
}
const handleFallback = async (fallback, error) => {
  return typeof fallback === 'function' ? fallback(error) : fallback;
};
export async function fetchWithFallback() {
  if (arguments.length <= 2) {
    return fetchWithOneFallback(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1]);
  } else {
    return fetchWithFallbacks(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
  }
}
async function fetchWithOneFallback(getter, fallback) {
  let result;
  try {
    result = await getter;
  } catch (error) {
    result = await handleFallback(fallback, error);
    return {
      ...result,
      error
    };
  }
  return result;
}
async function fetchWithFallbacks(getter, statusGetter, fallbacks) {
  const {
    error,
    ...result
  } = await fetchWithOneFallback(getter, fallbacks.default);
  if (error) {
    const status = statusGetter(error);
    const fallback = status && (await handleFallback(fallbacks[status], error));
    return {
      ...(status && fallbacks[status] || result),
      error: fallback ? undefined : error,
      status
    };
  }
  return result;
}
export async function fetchRPCWithFallback(getter, fallbacks) {
  return fetchWithFallbacks(getter, err => err.code, fallbacks);
}
//# sourceMappingURL=common.js.map